import React from 'react';
import PropTypes from 'prop-types';

const ProjectBanner = ({ title, imageUrl }) => {
  return (
    <div className="bg-gray-100 overflow-hidden shadow mb-4 lg:mb-6 rounded-xl">
      {/* Banner Image */}
      

      {/* Title Section */}
      <div className="p-3  bg-white">
        <h2 className="text-sm lg:text-base font-semibold text-gray-800">{title}</h2>
      </div>
    </div>
  );
};

// Prop Types for validation
ProjectBanner.propTypes = {
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

export default ProjectBanner;
